import { TipoDomandaDTO } from '@framework/api-client';

export type TipoDomandaInCollaudoDTO = TipoDomandaDTO & {
  stato: 'COLLAUDO';
};

export type TipoDomandaInBozzaConCollaudoDTO = TipoDomandaDTO & {
  stato: 'BOZZA';
  dataUltimaMessaInCollaudo: string;
};

export function isInquiryInTesting(
  inquiry: TipoDomandaDTO | undefined,
): inquiry is TipoDomandaInCollaudoDTO | TipoDomandaInBozzaConCollaudoDTO {
  const state = inquiry?.stato;
  return (
    state === 'COLLAUDO' ||
    (state === 'BOZZA' && inquiry?.dataUltimaMessaInCollaudo != null)
  );
}
